import { Entity } from './Entity';

/**
 * Component - Pure data container
 * Components hold data, systems hold logic
 */
export abstract class Component {
  /**
   * Unique identifier for this component type
   * Used for querying entities with specific components
   */
  public abstract readonly type: string;

  /**
   * Reference to the entity this component is attached to
   * Set automatically when added to an entity
   */
  public entity?: Entity;
}

/**
 * Helper function to create a component class
 * Provides a cleaner way to define components
 */
export function defineComponent<T extends object>(type: string, defaults: T): new (data?: Partial<T>) => Component & T {
  return class extends Component {
    public readonly type = type;

    constructor(data?: Partial<T>) {
      super();
      Object.assign(this, { ...defaults }, data);
    }
  } as new (data?: Partial<T>) => Component & T;
}
